import useApi from '../hook/useApi';

const useAuthApi = () => {
  const { sendRequest, loading, data, error } = useApi();

  const sendOtp = async (email) => {
    return sendRequest('/imp/send_otp_4_login', 'POST', { email });
  };

  const verifyOtp = async (email, otp) => {
    return sendRequest('/imp/verify_otp_4_login', 'POST', { email, otp });
  };

  return {
    sendOtp,  
    verifyOtp,
    loading,
    data,
    error,
  };
};

export default useAuthApi;